import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../api/api.service';
import { LocalserviceService } from '../../../api/localservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: 'app-paytable',
  templateUrl: './paytable.component.html',
  styleUrls: ['./paytable.component.css']
})
export class PaytableComponent implements OnInit {

  public itiHeaderName:any; 
  public itiHeaderemail:any; 
  public itiHeaderMobile:any; 
  public itiHeaderCode:any; 

  itiForm: any;
  reciveiticode:any = window.localStorage.getItem('ITICode');

  @ViewChild('paginator_Master') paginator_Master!: MatPaginator;
  @ViewChild('sort_Master') sort_Master!: MatSort;

  displayedColumnsMaster = ['slno', 'payrefid', 'payrefdate','noofstu', 'amount', 'ccaveref', 'paymentdate','pstatus'];
  SRC_SELECTED_FAMILYMEMBER_Master: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER_Master = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_Master);
  dataSource_Master = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_Master);
  selected_family_member_Master = new SelectionModel<Element>(true, []);
  public int_index_edit_Master: any;
  totallength_master:any = 1 ;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private httpClient: HttpClient) {

   }

  ngOnInit(): void {

    this.itiForm = this.formBuilder.group({
      iticode: this.reciveiticode,
    });

    this.api.showItiMasterTable(this.itiForm.value).subscribe((result: any) => {

      this.itiHeaderName = result[0]['itiname'];
      this.itiHeaderemail = result[0]['itiemail'];
      this.itiHeaderMobile = result[0]['itimobile'];
      this.itiHeaderCode = result[0]['iticode'];

      this.SRC_SELECTED_FAMILYMEMBER_Master = result;
      this.DATA_SELECTED_FAMILYMEMBER_Master = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_Master);
      this.dataSource_Master = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_Master);
      //this.ngAfterViewInit();
      this.dataSource_Master.paginator = this.paginator_Master;        
      this.dataSource_Master.sort = this.sort_Master;
      // this.bool_itiForm = false;
      console.log(JSON.stringify(result));
      // console.log(this.pduTable);
      this.totallength_master = result.length;
      console.log(JSON.stringify(result));
      // this.bool_table = false;
      // this.bool_Master_table = true;
      });

  }

  public printView:any;

  payMasterView(){
    
    this.selected_family_member_Master.selected.forEach((item:any) => {
      var msg = JSON.stringify(item);
      var msgOb = JSON.parse(msg)
      console.log("MSG: " + msg);
      
      const formData = new FormData();
      formData.append('data', msg);
    
      var myargs = formData;
      // var myargsText = this.uploadForm.value;
      console.log(msgOb.payrefid);
      
      // var args = {
      //   refid: msgOb.payrefid,
      //   iticode: msgOb.iticode
      // };

      // this.api.showViewPayrefid(args).subscribe((result: any) => {
      //   console.log(JSON.stringify(result));
      //   this.printView = result;
      //   this.bool_Master_table = false;
      //   this.bool_popup = true;
      // });
    });
  }

  payMaster(){
    this.selected_family_member_Master.selected.forEach((item:any) => {
      var msg = JSON.stringify(item);
      var msgOb = JSON.parse(msg)
      console.log("MSG: " + msg)
      const formData = new FormData();
      formData.append('data', msg);
    
      var myargs = formData;
      // var myargsText = this.uploadForm.value;
      console.log(msgOb.iticode);
  
   

      let a = {
        userid: msgOb.payrefid,
        amount: msgOb.amount,
        bname: msgOb.itiname,
        baddress: 'nimi',
        bcity: 'chennai',
        bdistrict: msgOb.districtname,
        bstate: msgOb.statename,
        bpincode: '600032',
        bmobile: msgOb.itimobile,
        bemail: msgOb.itiemail,
      };

     //window.location.href = 'https://www.nimionlineadmission.in/dgt/paynow.php'

     this.api.payMasterdata(a,"https://www.nimionlineadmission.in/dgt/paynow.php");

           this.selected_family_member_Master.clear() 
      // this.api.payMasterdata(myargs).subscribe((data: any) => {

      // });
      });
  }


}
